// MUI Imports
import Button from '@mui/material/Button'

// React Router Imports
import { Outlet } from 'react-router-dom'

// Layout Imports
import LayoutWrapper from '@layouts/LayoutWrapper'
import VerticalLayout from '@layouts/VerticalLayout'
import HorizontalLayout from '@layouts/HorizontalLayout'

// Component Imports
import Navigation from '@components/layout/vertical/Navigation'
import Header from '@components/layout/horizontal/Header'
import Navbar from '@components/layout/vertical/Navbar'
import ScrollToTop from '@core/components/scroll-to-top'
import IdleDetectionWrapper from '@components/IdleDetectionWrapper'
import Customizer from '@core/components/customizer'

// Util Imports
import { getMode, getSystemMode } from '@core/utils/serverHelpers'

const DashboardLayout = () => {
  const mode = getMode()
  const systemMode = getSystemMode()

  return (
    <>
      <LayoutWrapper
        systemMode={systemMode}
        verticalLayout={
          <VerticalLayout navigation={<Navigation mode={mode} systemMode={systemMode} />} navbar={<Navbar />}>
            <IdleDetectionWrapper>
              <Outlet />
            </IdleDetectionWrapper>
          </VerticalLayout>
        }
        horizontalLayout={
          <HorizontalLayout header={<Header />}>
            <Outlet />
          </HorizontalLayout>
        }
      />
      <ScrollToTop className='mui-fixed'>
        <Button variant='contained' className='is-10 bs-10 rounded-full p-0 min-is-0 flex items-center justify-center'>
          <i className='tabler-arrow-up' />
        </Button>
      </ScrollToTop>
      <Customizer disableDirection />
    </>
  )
}

export default DashboardLayout
